<template>
  <div class="mt-2">
    <WarningDisable permission="process" />
    <div class="flex flex-wrap gap-6">
      <div>
        <form
          ref="status_form"
          class="mb-4 space-y-4"
          @submit="submit_without_reloading"
          @reset="keyword = undefined"
        >
          <div class="space-y-2">
            <div>
              <legend>Từ khóa</legend>
              <label class="input w-full md:w-fit 2xl:w-fit">
                <i
                  class="fa-solid fa-magnifying-glass text-base-content/80"
                ></i>
                <input
                  type="text"
                  placeholder="Tìm kiếm theo từ khóa"
                  name="keyword"
                  v-model="keyword"
                />
              </label>
            </div>
          </div>
          <div class="flex flex-wrap gap-2">
            <input
              class="btn btn-outline grow"
              type="reset"
              value="&#8635; Đặt lại"
              :disabled="process_store.loading.get_processes"
            />
            <button
              class="btn btn-primary btn-outline grow"
              type="submit"
              :disabled="
                !filter_has_changed || process_store.loading.get_processes
              "
            >
              &#10003; Áp dụng
            </button>
          </div>
        </form>
      </div>

      <div class="flex grow flex-col overflow-x-auto">
        <div class="text-base-content/80 mb-2 text-xl font-bold">
          Danh sách tiến trình
        </div>
        <Loading v-if="process_store.loading.get_processes" />
        <template v-else-if="process_store.total_filter > 0">
          <div class="bg-base-100 mb-2 overflow-x-auto">
            <table class="table-pin-rows table-md border-base-300 table border">
              <thead>
                <tr>
                  <th>PID</th>
                  <th>Tên tiến trình</th>
                  <th>Đường dẫn</th>
                  <th>Trạng thái</th>
                  <th>Người dùng</th>
                  <th>Thời gian tạo</th>
                  <th></th>
                </tr>
              </thead>
              <tbody class="bg-base-200">
                <tr
                  v-for="process in process_store.processes"
                  :key="process.id"
                >
                  <td>{{ process?.pid }}</td>
                  <td class="text-base-content/80 text-base font-bold">
                    {{ process?.name }}
                  </td>
                  <td>
                    {{ process?.path }}
                  </td>
                  <td>
                    <ProcessStatus :status="process.status?.toLowerCase()" />
                  </td>
                  <td>{{ process?.user }}</td>
                  <td>{{ dayjs(process?.created).fromNow() }}</td>
                  <td>
                    <ActionMenu :process="process" />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <Pagination :total_pages="process_store.total_pages" />
        </template>
        <NotFound v-else />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { str_from_query } from "@/api";
import Loading from "@/components/LoadingTemplate.vue";
import NotFound from "@/components/NotFound.vue";
import Pagination from "@/components/PaginationTemplate.vue";
import { router } from "@/router/router";
import dayjs from "dayjs";
import { computed, ref } from "vue";
import WarningDisable from "../WarningDisable.vue";
import ActionMenu from "./ActionMenu.vue";
import ProcessStatus from "./ProcessStatus.vue";
import { use_process } from "./useProcess";

const init_keyword = computed(() => str_from_query("keyword"));

const keyword = ref<string | undefined>(init_keyword.value);
const filter_has_changed = computed(() => keyword.value !== init_keyword.value);
const process_store = use_process();

const submit_without_reloading = (e: Event) => {
  e.preventDefault();
  router.push({
    name: router.currentRoute.value.name,
    query: {
      ...router.currentRoute.value.query,
      page: 1,
      keyword: keyword.value,
    },
  });
};
</script>
